import React from "react";
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import Image from "next/image";
import ContentHeader from "../ContentHeader/ContentHeader";
import { CardComponent, PaperComponent } from "@/components";
import styles from "../../personal-loan-landing.module.css";
import { Height } from "@mui/icons-material";

const cities = [
  {
    name: "Chennai",
    image: IMAGES.chennai,
  },
  {
    name: "Hyderabad",
    image: IMAGES.hyderabad,
  },
  {
    name: "Kerala",
    image: IMAGES.kerala,
  },
  {
    name: "Pune",
    image: IMAGES.pune,
  },
  {
    name: "Coimbatore",
    image: IMAGES.coimbatore,
  },
  {
    name: "Delhi",
    image: IMAGES.delhi,
  },
  {
    name: "Baroda",
    image: IMAGES.baroda,
  },

  {
    name: "Ahmedabad",
    image: IMAGES.ahmedabad,
  },
  {
    name: "Mumbai",
    image: IMAGES.mumbai,
  },
  {
    name: "Surat",
    image: IMAGES.surat,
  },
  {
    name: "Kolkata",
    image: IMAGES.kolkata,
  },
  {
    name: "Trivandrum",
    image: IMAGES.trivandrum,
  },
  // Add more cities here with their respective images
];

const CityLoanGrid = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ p: { xs: 2, md: 8 }, backgroundColor: { xs: "#fff", md: "#F1FFF0" } }}>
      <ContentHeader
        heading={"Your City, Your Loan – Fast & Easy"}
        paragraph={
          "Find the best personal loan offers tailored to your city and needs."
        }
      />
      <Grid container spacing={4}>
        {cities.map((city, index) => (
          <Grid item xs={6} md={4} key={`${city.name}-${index}`}>
            <PaperComponent
              sx={{
                position: "relative",
                borderRadius: 2,
                boxShadow: 3,
                p: 1,
                backgroundColor: { md: "#fff", xs: "#F1FFF0" },
                display: "flex",
                flexDirection: {
                  xs: "column",
                  md: "row",
                },
                alignItems: {
                  xs: "center",
                },
                justifyContent: {
                  xs: "flex-start",
                  md: "flex-start",
                },
                gap: 1,
                width: {
                  xs:'150px',
                  md:'100%'
                },
                height: {
                  xs: 180,
                  md: "100%",
                },
              }}
            >
              <Image
                src={city?.image}
                alt={city?.name}
                className={styles["city-img"]}
                loading="lazy"
              />
              <Box>
                <Typography
                  variant="subtitle1"
                  fontWeight="500"
                  color="#111111"
                  mb={1}
                  sx={{
                    fontSize: {
                      xs: 14,
                      md: 16,
                    },
                    textAlign: "left",
                    lineHeight: "100%",
                  }}
                >
                  Personal Loan in {city.name}
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="subtitle1"
                  fontWeight="500"
                  color={WEB_COLORS.darkTeal}
                  // mb={1}
                  sx={{
                    backgroundColor: {
                      md: "#f1f1f6",
                      xs: "fff",
                    },
                    position: {
                      md: "absolute",
                      xs: "relative",
                    },
                    p: {
                      md: 1,
                      xs: 0,
                    },
                    bottom: "0",
                    right: "0",
                    textAlign: "left",
                    fontSize: {
                      xs: "12px",
                      md: "16px",
                    },
                    borderTopLeftRadius: {
                      xs: "0",
                      md: 10,
                    },
                    borderTopRightRadius: {
                      xs: "0",
                      md: 5,
                    },
                    borderBottomLeftRadius: {
                      xs: "0",
                      md: 5,
                    },
                    borderBottomRightRadius: {
                      xs: "0",
                      md: 5,
                    },
                  }}
                >
                  Learn More
                </Typography>
              </Box>
            </PaperComponent>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CityLoanGrid;
